import React, { useState, useEffect } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Icon from "../doctor-console/Utils/Icons";
import { ReactComponent as CLoseIcon } from "./DummyIcons/CloseButton.svg";
// import { ReactComponent as CLoseIcon } from "./IconsForTiles/CloseButton.svg";
import {
  DataGrid,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarDensitySelector,
} from "@mui/x-data-grid";
import {
  Modal,
  Box,
  TextField,
  Stack,
  Button,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Tooltip,
  Fab,
} from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import axios from "axios";
import "./BillingPayment.scss";
import { CheckToken } from "../login/AccessToken";
import { displayPatientName } from "../../utils/displayPatientName";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { toast } from "react-toastify";
import showConfirmDialog from "../../components/ShowConfirmDialog/ShowConfirmDialog";
import SideNavbar from "./SideNavbar";
import NoDataPage from "./NoDataPage";
import { Card, Typography, Divider } from "@mui/material";
import SaveAlt from "@mui/icons-material/SaveAlt";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import "jspdf-autotable";

import { ReactComponent as CalendarIcon } from './DummyIcons/calendar-silhouette 2.svg';

const Payment = () => {
  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    register,
    formState: { errors },
    watch,
  } = useForm();
  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const today = new Date().toISOString().split("T")[0];
  const [facilityName, setFacilityName] = useState(
    sessionStorage.getItem("facility_name") || ""
  );
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const history = useHistory();
  const Token = () => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  const [patientId, setPatientId] = useState("");

  const [isModalOpen, setModalOpen] = useState(false);
  const [paymentsList, setPaymentsList] = useState([]);
  const [editPaymentId, setEditPaymentId] = useState(null);
  const [invoiceList, setInvoiceList] = useState([]);

  useEffect(() => {
    if (!authToken) return;
    fetchPayments();
    fetchInvoiceList();
  }, [authToken]);
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);
  useEffect(() => {
    const selectedInvoice = invoiceList.find(
      (invoice) => invoice.invoice_number === watch("invoice_number")
    );
    if (selectedInvoice) {
      setPatientId(selectedInvoice.patient_id);
    }
  }, [watch("invoice_number")]);

  console.log("watch", patientId);

  const fetchPayments = () => {
    axios
      .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_payments/`, {
        headers: headers,
      })
      .then((res) => {
        const paymentsWithId = res.data.payments.map((payment) => ({
          ...payment,
          id: payment.payment_id,
        }));

        setPaymentsList(paymentsWithId);
      })
      .catch((error) => {
        console.error("Error fetching payments:", error);
      });
  };

  const fetchInvoiceList = () => {
    if (!authToken) return;

    (async () => {
      try {
        // Preferred: ask backend for full list in one go.
        const res = await axios.post(
          `${REACT_APP_BACKEND_ROUTE_URL}get_all_invoices/`,
          { hip_id: facilityName, is_pagination_required: false },
          { headers: { Authorization: `Bearer ${authToken}` } }
        );

        const pg = res?.data?.pagination;
        const invoices = Array.isArray(res?.data?.invoices) ? res.data.invoices : [];

        // If backend still paginates even when flag=false, fall back to paging all.
        const backendIgnoredFlag = Boolean(pg?.has_next);
        if (backendIgnoredFlag) {
          const LIMIT = 100; // backend caps limit to 100
          const MAX_PAGES_SAFETY = 1000;
          let page = 1;
          let allInvoices = [];
          let pagesFetched = 0;

          while (pagesFetched < MAX_PAGES_SAFETY) {
            const r = await axios.post(
              `${REACT_APP_BACKEND_ROUTE_URL}get_all_invoices/`,
              {
                hip_id: facilityName,
                is_pagination_required: true,
                page,
                limit: LIMIT,
              },
              { headers: { Authorization: `Bearer ${authToken}` } }
            );

            const pageInvoices = Array.isArray(r?.data?.invoices)
              ? r.data.invoices
              : [];
            allInvoices = allInvoices.concat(pageInvoices);

            const p = r?.data?.pagination;
            if (!p || !p.has_next) break;

            const next = p.next_page;
            if (typeof next === "number" && next > page) {
              page = next;
            } else {
              page = page + 1;
            }

            pagesFetched += 1;
          }

          const invoicesWithId = allInvoices.map((invoice) => ({
            ...invoice,
            id: invoice.invoice_id,
            total: parseFloat(invoice.total_amount).toFixed(2),
          }));
          setInvoiceList(invoicesWithId);
          return;
        }

        const invoicesWithId = invoices.map((invoice) => ({
          ...invoice,
          id: invoice.invoice_id,
          total: parseFloat(invoice.total_amount).toFixed(2),
        }));
        setInvoiceList(invoicesWithId);
      } catch (error) {
        console.error("Error fetching invoice list:", error);
      }
    })();
  };

  const handleAddPayment = () => {
    setModalOpen(true);
    reset();
  };

  const handleEditPayment = (row) => {
    console.log("row", row);
    setModalOpen(true);
    reset({
      date: row.date,
      payment_number: row.payment_number,
      payment_mode: row.payment_mode,
      invoice_number: row.invoice,
      amount: row.amount,
      status: row.status,
      note: row.note,
    });
    setEditPaymentId(row.id);
  };

  const handleModalClose = () => {
    setModalOpen(false);
    reset();
    reset({
      date: "",
      payment_mode: "Credit Card",
      invoice_number: "",
      amount: "",
      note: "",
    });

    setEditPaymentId(null);
  };

  const handleSavePayment = (data) => {
    console.log(data, "data1");
    // let requestData;

    console.log("ttt", data.invoice_number);
    // const selectedInvoice = invoiceList.find((invoice) => invoice.invoice_number === data.invoice_number);
    // if (!selectedInvoice) {
    //   console.error('Error: Unable to find associated invoice.');
    //   return;
    // }

    // console.log("Selected Invoice:", selectedInvoice);
    // const requestData = {
    //   "hip_id": facilityName,
    //   patient_id: selectedInvoice.customer,
    //   ...data,
    // };

    // if (!editPaymentId) {
    //   const selectedInvoice = invoiceList.find((invoice) => invoice.invoice_number === data.invoice_number);
    //   if (!selectedInvoice) {
    //     console.error('Error: Unable to find associated invoice.');
    //     return;
    //   }
    //   patientId
    //   console.log("Selected Invoice:", selectedInvoice);
    //   requestData = {
    //     "hip_id": facilityName,
    //     patient_id: selectedInvoice.customer,
    //     ...data,
    //   };
    // }

    // const requestData = {
    //   "hip_id": facilityName,
    //   patient_id: patientId,
    //   ...data,
    // };
    // console.log("last", requestData)

    const getPatientName = (invoiceNumber) => {
      const invoice = invoiceList.find(
        (inv) => inv.invoice_number === invoiceNumber
      );
      return invoice
        ? displayPatientName(invoice.patient_name, "Unknown Patient")
        : "Unknown Patient";
    };

    if (editPaymentId) {
      // Update operation
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}update_payment/`,
          { payment_id: editPaymentId, ...data, hip_id: facilityName },
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.data.status === "Success") {
            toast.success(response.data.message);
            reset({
              date: "",
              payment_mode: "",
              invoice_number: "",
              amount: "",
              note: "",
            });
            setEditPaymentId("");
          } else {
            toast.error(response.data.error);
          }
          fetchPayments();
          setModalOpen(false);
        })
        .catch((error) => {
          console.error("Error saving payment:", error);
        });
    } else {
      // Add operation
      const patientName = getPatientName(data.invoice_number);
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}create_payment/`,
          { hip_id: facilityName, ...data },
          {
            headers: headers,
          }
        )
        .then((response) => {
          if (response.data.status === "Success") {
            toast.success(
              `${response.data.message} for patient: ${patientName}`
            );
            reset({
              date: "",
              // patient_id: "",
              payment_mode: "",
              invoice_number: "",
              amount: "",
              note: "",
            });
          } else {
            toast.error(response.data.error);
          }

          fetchPayments();
          setModalOpen(false);
          reset();
        })
        .catch((error) => {
          console.error("Error saving payment:", error);
        });
    }
  };

  // const handleDeletePayment = (id) => {
  //   // Delete operation
  //   axios
  //     .post(`${REACT_APP_BACKEND_ROUTE_URL}delete_payment/`, { payment_id: id }, {
  //       headers: headers,
  //     })
  //     .then(() => {
  //       // Fetch updated payments after the operation
  //       fetchPayments();
  //     })
  //     .catch((error) => {
  //       console.error('Error deleting payment:', error);
  //     });
  // };
  const getRowClassName = (params) => {
    return "custom-row";
  };
  const handleDeletePayment = async (id) => {
    const message = `Are you sure you want to delete this payment?`;
    const confirmDelete = await showConfirmDialog(message);

    if (confirmDelete) {
      axios
        .post(
          `${REACT_APP_BACKEND_ROUTE_URL}delete_payment/`,
          { payment_id: id },
          {
            headers: headers,
          }
        )
        .then((res) => {
          if (res.data.status == "Success") {
            toast.success(res.data.status);
            fetchPayments();
          } else {
            toast.error("Error in payment");
          }
        })
        .catch((error) => {
          console.error("Error deleting payment:", error);
        });
    } else {
      console.log("Payment deletion canceled.");
    }
  };

  const generatePdf = () => {
    const doc = new jsPDF();

    // const tableColumns = [
    //   "Payment Number",
    //   "Date",
    //   "Patient",
    //   "Patient Name",
    //   "Payment Mode",
    //   "Invoice Number",
    //   "Amount",
    // ];
    doc.autoTable({
      head: [["Payment Number", "Date", "Patient", "Patient Name", "Payment Mode", "Invoice Number", "Amount"]],
      body: paymentsList.map((payment) => [
        payment.payment_number,
        payment.date,
        payment.customer_id,
        payment.customer_name,
        payment.payment_mode,
        payment.invoice,
        payment.amount,
      ])
    });
    doc.save('payment_records.pdf');
  };

  const generateCsvData = () => {
    return paymentsList.map((payment) => ({
      "Payment Number": payment.payment_number,
      "Date": payment.date,
      "Patient": payment.customer_id,
      "Patient Name": payment.customer_name,
      "Payment Mode": payment.payment_mode,
      "Invoice Number": payment.invoice,
      "Amount": payment.amount,
    }));
  };

  return (
    <>
      {/* <Modal open={isModalOpen} onClose={handleModalClose}>
        <Box
          sx={{
            width: {
              xs: "100%",
              sm: "75%",  // 75% width on small screens
              md: "75%",  // 50% width on medium screens
              lg: "40%",  // 40% width on large screens
              xl: "30%",  // 30% width on extra-large screens
            },
            p: 2,
            mt: 3,
            mx: "auto",
            bgcolor: "background.paper",
            borderRadius: 1,
          }}
        >
          <form onSubmit={handleSubmit(handleSavePayment)}>
            <div className="col-12">
              <label htmlFor="date" className="required-label">
                Date{" "}
              </label>
              <div className="form-group">
                <div className="form-group form-group-date">
                  <input
                    min={today}
                    max="2050-01-01"
                    id="PaymentDate"
                    type="date"
                    className="form-control"
                    {...register("date", { required: "Date is required" })}
                  />
                  <i className="position-absolute" style={{ right: '10px', top: '50%', transform: 'translateY(-50%)' }}>
                    <CalendarIcon
                      onClick={() =>
                        document.getElementById("PaymentDate").showPicker?.()
                      }
                    />
                  </i>
                  {errors.date && (
                    <p className="error-message">{errors.date.message}</p>
                  )}
                </div>
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="payment_mode" className="required-label">
                Payment Mode{" "}
              </label>
              <div className="form-group">
                <FormControl fullWidth>
                  <select
                    className="form-control"
                    {...register("payment_mode", {
                      required: "Payment Mode is required",
                    })}
                  >
                    <option value="Credit Card">Credit Card</option>
                    <option value="Debit Card">Debit Card</option>
                    <option value="Cash">Cash</option>
                  </select>
                  {errors.payment_mode && (
                    <p className="error-message">
                      {errors.payment_mode.message}
                    </p>
                  )}
                </FormControl>
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="invoice_number" className="required-label">
                Invoice Number{" "}
              </label>
              <div className="form-group">
                <FormControl fullWidth>
                  <select
                    className="form-control"
                    {...register("invoice_number", {
                      required: "Invoice Number is required",
                    })}
                  >
                    {invoiceList.map((invoice) => (
                      <option key={invoice.id} value={invoice.invoice_number}>
                        {invoice.invoice_number}
                      </option>
                    ))}
                  </select>
                  {errors.invoice_number && (
                    <p className="error-message">
                      {errors.invoice_number.message}
                    </p>
                  )}
                </FormControl>
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="amount" className="required-label">
                Amount(Rs){" "}
              </label>
              <div className="form-group">
                <input
                  type="number"
                  className="form-control"
                  {...register("amount", { required: "Amount is required" })}
                />
                {errors.amount && (
                  <p className="error-message">{errors.amount.message}</p>
                )}
              </div>
            </div>

            <div className="col-12">
              <label htmlFor="note" className="required-label">
                Note{" "}
              </label>
              <div className="form-group">
                <input
                  type="text"
                  className="form-control"
                  {...register("note", { required: "Note is required" })}
                />
                {errors.note && (
                  <p className="error-message">{errors.note.message}</p>
                )}
              </div>
            </div>

            <div className="col-12">
              <button
                type="submit"
                className="btn btn__secondary btn__rounded btn__block mt-2"
              >
                Save
              </button>

              <button
                onClick={handleModalClose}
                type="button"
                className="btn btn__secondary btn__rounded btn__block mt-2"
              >
                Cancel
              </button>
            </div>
          </form>
        </Box>
      </Modal> */}

      <Modal
        open={isModalOpen}
        onClose={handleModalClose}
        style={{
          // backdropFilter: "blur(5px)",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <Box
          sx={{
            width: {
              xs: "95%",
              sm: "80%",
              md: "70%",
              lg: "45%",
              xl: "35%",
            },
            maxHeight: "140vh",
            p: 2,
            mt: 3,
            mx: "auto",
            bgcolor: "background.paper",
            borderRadius: "10px",
            padding: 0,
          }}
        >
          <Box
            sx={{
              // display: "flex",
              // justifyContent: "space-between",
              // alignItems: "center",
              // bgcolor: "background.paper",
              // p: 1,
              // borderRadius: 1,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              // backgroundImage: `url(${Icons.modal_blue})`,
              backgroundColor: "#213360",
              height: { xs: 50, sm: 60},
              // borderBottom: "1px solid #ddd",
              borderBottom: "1px solid rgba(255,255,255,0.15)",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: { xs: 1, sm: 2 },
              borderTopLeftRadius: "8px",
              borderTopRightRadius: "8px",
              flexShrink: 0,
            }}
          >
            <Typography variant="h6" sx={{
              // fontSize: { xs: "1.1rem", sm: "1.25rem" },
              fontSize: "20px",
              fontWeight: 550,
              color: "#FFFFFF",
            }}>
              Add New Payment
            </Typography>
            <CLoseIcon
              onClick={handleModalClose}
              style={{
                width: "20px",
                height: "20px",
                cursor: "pointer",
                transition: "all 0.3s ease",
                "&:hover": {
                  border: "1px solid #000",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  transform: "scale(1.1)",
                },
              }}
            />
          </Box>
          <Box overflow="auto" sx={{
            bgcolor: "#ffffff", p: 2, '&::-webkit-scrollbar': {
              width: '4px',
            },
            '&::-webkit-scrollbar-track': {
              background: '#f1f1f1',
            },
            '&::-webkit-scrollbar-thumb': {
              background: '#0B0F35',
              borderRadius: '4px',
            },
            '&::-webkit-scrollbar-thumb:hover': {
              background: '#0B0F35cc',
            }, borderRadius: 1, maxHeight: "100vh"
          }}>
            <Box overflow="auto"
              sx={{
                '&::-webkit-scrollbar': {
                  width: '4px',
                },
                '&::-webkit-scrollbar-track': {
                  background: '#f1f1f1',
                },
                '&::-webkit-scrollbar-thumb': {
                  background: '#0B0F35',
                  borderRadius: '4px',
                },
                '&::-webkit-scrollbar-thumb:hover': {
                  background: '#0B0F35cc',
                },
                display: "flex",
                flexDirection: "column",
                bgcolor: "background.paper",
                p: 2,
                borderRadius: 1,
                width: "100%",
                maxHeight: "70vh",
                // overflowY: "auto"
              }}
            >
              <form
                onSubmit={handleSubmit(handleSavePayment)}
                style={{ display: "flex", flexDirection: "column", width: "100%", height: "100%" }}
              >
                <div className="col-12" style={{ flex: "1", marginBottom: "0.5rem" }}>
                  <label htmlFor="date" className="required-label">
                    Date{" "}
                  </label>
                  <div className="form-group" style={{ width: "100%" }}>
                    <div className="form-group form-group-date">
                      <input
                        min={today}
                        max="2050-01-01"
                        id="PaymentDate"
                        type="date"
                        className="form-control"
                        {...register("date", { required: "Date is required" })}
                        style={{ width: "100%" }}
                      />
                      <i
                        className="position-absolute"
                        style={{ right: "10px", top: "50%", transform: "translateY(-50%)" }}
                      >
                        <CalendarIcon
                          onClick={() => document.getElementById("PaymentDate").showPicker?.()}
                        />
                      </i>
                      {errors.date && <p className="error-message">{errors.date.message}</p>}
                    </div>
                  </div>
                </div>
                <div className="col-12 d-flex" style={{ marginBottom: "0.5rem", padding: "0" }}>
                  <div className="col-6" style={{ flex: "1" }}>
                    <label htmlFor="invoice_number" className="required-label">
                      Invoice Number{" "}
                    </label>
                    <div className="form-group" style={{ width: "100%" }}>
                      <FormControl fullWidth>
                        <select
                          className="form-control"
                          {...register("invoice_number", {
                            required: "Invoice Number is required",
                          })}
                          style={{ width: "100%"}}
                        >
                          {invoiceList.map((invoice) => (
                            <option key={invoice.id} value={invoice.invoice_number}>
                              {invoice.invoice_number}
                            </option>
                          ))}
                        </select>
                        {errors.invoice_number && (
                          <p className="error-message">{errors.invoice_number.message}</p>
                        )}
                      </FormControl>
                    </div>
                  </div>
                  <div className="col-6" style={{ flex: "1" }}>
                    <label htmlFor="payment_mode" className="required-label">
                      Payment Mode{" "}
                    </label>
                    <div className="form-group" style={{ width: "100%" }}>
                      <FormControl fullWidth>
                        <select
                          className="form-control"
                          {...register("payment_mode", {
                            required: "Payment Mode is required",
                          })}
                          style={{ width: "100%" }}
                        >
                          <option value="Credit Card">Credit Card</option>
                          <option value="Debit Card">Debit Card</option>
                          <option value="Cash">Cash</option>
                        </select>
                        {errors.payment_mode && (
                          <p className="error-message">{errors.payment_mode.message}</p>
                        )}
                      </FormControl>
                    </div>
                  </div>
                </div>

                <div className="col-12" style={{ flex: "1", marginBottom: "0.5rem" }}>
                  {/* <div className="col-6 pr-2" style={{ flex: "1", marginRight: "1rem" }}> */}
                  <label htmlFor="amount" className="required-label">
                    Amount(Rs){" "}
                  </label>
                  <div className="form-group" style={{ width: "100%" }}>
                    <input
                      type="number"
                      className="form-control"
                      {...register("amount", { required: "Amount is required" })}
                      style={{ width: "100%" }}
                    />
                    {errors.amount && <p className="error-message">{errors.amount.message}</p>}
                  </div>
                </div>
                {/* </div> */}
                <div className="col-12" style={{ flex: "1", marginBottom: "0.5rem" }}>
                  <label htmlFor="note" className="required-label">
                    Note{" "}
                  </label>
                  <div className="form-group" style={{ width: "100%" }}>
                    <input
                      type="text"
                      className="form-control"
                      {...register("note", { required: "Note is required" })}
                      style={{ width: "100%" }}
                    />
                    {errors.note && <p className="error-message">{errors.note.message}</p>}
                  </div>
                </div>

                <div className="col-12 d-flex" style={{ marginBottom: "0.5rem", padding: "0" }}>
                  <div className="col-6" style={{ flex: "1" }} >
                    <button
                      type="submit"
                      className="btn btn__secondary btn__block mt-2"
                      style={{ width: "100%", marginBottom: "1rem", borderRadius: "10px", border: "1px solid #125386" }}
                    >
                      SAVE
                    </button></div>
                  <div className="col-6" style={{ flex: "1" }}>
                    <button
                      onClick={handleModalClose}
                      type="button"
                      className="btn btn__secondary btn__block mt-2"
                      style={{ width: "100%", borderRadius: "10px", border: "1px solid #125386" }}
                    >
                      CANCEL
                    </button>
                  </div></div>
                {/* <div className="col-12" style={{ flex: "1" }}>
                  <button
                    type="submit"
                    className="btn btn__secondary btn__block mt-2"
                    style={{ width: "100%", marginBottom: "1rem", backgroundColor: "#0E3F66", borderRadius: "10px", border: "1px solid #125386" }}
                  >
                    Save
                  </button>
                  <button
                    onClick={handleModalClose}
                    type="button"
                    className="btn btn__secondary btn__block mt-2"
                    style={{ width: "100%", backgroundColor: "#0E3F66", borderRadius: "10px", border: "1px solid #125386" }}
                  >
                    Cancel
                  </button>
                </div> */}
              </form>
            </Box>
          </Box>
          {/* <Box sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            bgcolor: "background.paper",
            p: 1,
            borderRadius: 2,
          }}>
            <button
              type="submit"
              className="btn btn__secondary btn__block mt-2"
              style={{ width: "100%", marginBottom: "1rem", backgroundColor: "#0E3F66", borderRadius: "10px", border: "1px solid #125386" }}
            >
              Save
            </button>
            <button
              onClick={handleModalClose}
              type="button"
              className="btn btn__secondary btn__block mt-2"
              style={{ width: "100%", backgroundColor: "#0E3F66", borderRadius: "10px", border: "1px solid #125386" }}
            >
              Cancel
            </button>
          </Box> */}
        </Box>
      </Modal>


      <SideNavbar />
      {/* <p style={{ padding: "25px", fontSize: "32px", fontWeight: "bold", textAlign: "left", color: "#172935" }}>Payment records</p>
      {/* <Button onClick={handleAddPayment} variant="contained" color="primary" style={{align: "right", backgroundColor: "#0E3F66",  borderRadius: "8px",marginBottom:"10px", fontSize: "14px", marginLeft:"675px"}}>
        + Add Payment
      </Button> */}
      {/* <Box
        sx={{
          display: "flex",
          justifyContent: { xs: "center", sm: "flex-end" }, // Center on extra-small screens, align right on small and larger
          marginBottom: "10px",
          paddingX: { xs: 2, sm: 3 }, // Add padding for smaller screens
        }}
      >
        <Button
          onClick={handleAddPayment}
          variant="contained"
          color="primary"
          sx={{
            backgroundColor: "#0E3F66",
            borderRadius: "8px",
            fontSize: "14px",
            paddingX: { xs: 2, sm: 3 }, // Adjust padding for smaller screens
            paddingY: 1,
            textTransform: "none", // Optional: to match typical button text style
            "&:hover": {
              backgroundColor: "#0C3555", // Slightly darker shade for hover
            },
          }}
        >
          + Add Payment
        </Button> 
      </Box> */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "1fr auto", // One column for text, one for button
          alignItems: "center",
          padding: "12px",
          gap: "20px", // Space between text and button
          marginBottom: "5px",
          // paddingX: { xs: 2, sm: 3 }, // Add padding for smaller screens
        }}
      >
        <p
          style={{
            fontSize: "32px",
            fontWeight: "bold",
            textAlign: "left",
            color: "#172935",
            margin: 0, // Remove default margin to align properly
          }}
        >
          Payment records
        </p>
        <button
          onClick={handleAddPayment}
          type="button"
          className="btn btn__secondary btn__rounded btn__block mt-2"
          // variant="contained"
          // color="primary"
          style={{
            backgroundColor: "#0E3F66",
            borderRadius: "10px",
            fontSize: "14px",
            paddingX: { xs: 2, sm: 3 },
            paddingY: 1,
            textTransform: "none",
            // "&:hover": {
            //   backgroundColor: "#0C3555",
            // },
          }}
        >
          + Add Payment
        </button>
      </Box>
      <div className="display-flex">
        {paymentsList !== undefined && paymentsList.length > 0 ? (
          <DataGrid
            rows={paymentsList}
            columns={[
              {
                field: "payment_number",
                headerName: "Payment Number",
                width: 190,
              },
              { field: "date", headerName: "Date", width: 150 },
              { field: "customer_id", headerName: "Patient", width: 150 },
              {
                field: "customer_name",
                headerName: "Patient Name",
                width: 150,
                renderCell: (params) => (
                  <span style={{ textTransform: "uppercase" }}>{params.value}</span>
                ),
              },
              { field: "payment_mode", headerName: "Payment Mode", width: 150 },
              { field: "invoice", headerName: "Invoice Number", width: 150 },
              { field: "amount", headerName: "Amount", width: 100 },
              {
                field: "edit",
                headerName: "Edit",
                width: 100,
                renderCell: (params) => (
                  <Tooltip title="Edit Payment">
                    <EditIcon
                      onClick={() => handleEditPayment(params.row)}
                      style={{ cursor: "pointer", color: "#0D233F" }}
                    />
                  </Tooltip>
                ),
              },
              {
                field: "delete",
                headerName: "Delete",
                width: 100,
                renderCell: (params) => (
                  <Tooltip title="Delete Payment">
                    <DeleteIcon
                      onClick={() => handleDeletePayment(params.row.id)}
                      style={{ cursor: "pointer", color: "#0D233F" }}
                    />
                  </Tooltip>
                ),
              },
            ]}
            components={{
              Toolbar: () => (
                <Grid
                  container
                  spacing={2}
                  alignItems="center"
                  justifyContent="space-between"
                  sx={{
                    mb: 2,
                  }}
                >
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={8}
                    sx={{ display: "flex", gap: 1 }}
                  >
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton />
                    <GridToolbarDensitySelector />
                  </Grid>

                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={4}
                    sx={{
                      display: "flex",
                      gap: 1,
                      justifyContent: { xs: "center", sm: "flex-end" },
                    }}
                  >
                    <Button
                      variant="text"
                      color="primary"
                      onClick={() => generatePdf()}
                      startIcon={<SaveAlt />}
                    >
                      Download PDF
                    </Button>
                    <CSVLink
                      data={generateCsvData()}
                      filename={"scan_share_records.csv"}
                      target="_blank"
                    >
                      <Button
                        variant="text"
                        color="primary"
                        startIcon={<SaveAlt />}
                      >
                        Download CSV
                      </Button>
                    </CSVLink>
                  </Grid>
                </Grid>
              ),
            }}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[5, 10]}
            getRowClassName={getRowClassName}
            sx={{
              "& .MuiDataGrid-root": {
                border: "1px solid #e0e0e0",
                borderRadius: "4px",
                fontFamily: "Arial, sans-serif",
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#125386",
                color: "white",
                fontSize: "13px",
                fontWeight: "600",
                minHeight: "48px !important",
                "& .MuiDataGrid-columnHeaderTitle": {
                  color: "white",
                  fontWeight: "600",
                  fontSize: "13px",
                },
                "& .MuiDataGrid-columnHeader": {
                  borderRight: "1px solid rgba(255, 255, 255, 0.3)",
                  padding: "0 12px",
                },
                "& .MuiDataGrid-columnHeader:last-child": {
                  borderRight: "none",
                },
                "& .MuiDataGrid-iconButtonContainer": {
                  color: "white",
                },
                "& .MuiDataGrid-menuIcon": {
                  color: "white",
                },
                "& .MuiDataGrid-sortIcon": {
                  color: "white",
                },
                "& .MuiDataGrid-columnHeaderSortable": {
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                },
                "& .MuiDataGrid-columnHeaderTitleContainer": {
                  "& .MuiDataGrid-sortIcon": {
                    color: "white",
                  },
                },
                "& .MuiSvgIcon-root": {
                  color: "white",
                },
              },
              "& .MuiDataGrid-row": {
                backgroundColor: "white",
                minHeight: "40px !important",
                "&:nth-of-type(even)": {
                  backgroundColor: "white",
                },
                "&:hover": {
                  backgroundColor: "#f8f9fa",
                },
                "&.Mui-selected": {
                  backgroundColor: "#e3f2fd",
                  "&:hover": {
                    backgroundColor: "#e3f2fd",
                  },
                },
                borderBottom: "1px solid #e0e0e0",
              },
              "& .MuiDataGrid-cell": {
                borderRight: "1px solid #e0e0e0",
                fontSize: "12px",
                color: "#374151",
                padding: "8px 12px",
                minHeight: "40px !important",
                "&:last-child": {
                  borderRight: "none",
                },
                "&:focus": {
                  outline: "none",
                },
              },
              "& .MuiDataGrid-cellContent": {
                fontSize: "12px",
                color: "#374151",
                fontWeight: "400",
              },
              "& .MuiDataGrid-footerContainer": {
                backgroundColor: "#f8f9fa",
                borderTop: "1px solid #e0e0e0",
                minHeight: "52px",
              },
              "& .MuiTablePagination-root": {
                color: "#374151",
                fontSize: "12px",
              },
              "& .MuiDataGrid-toolbarContainer": {
                backgroundColor: "#f8f9fa",
                borderBottom: "1px solid #e0e0e0",
                padding: "8px 16px",
              },
            }}
          />
        ) : (
          <NoDataPage />
        )}
      </div>
    </>
  );


};

export default Payment;
